import { Autocomplete, AutocompleteProps, createFilterOptions, TextField } from '@mui/material';
import { useCallback } from 'react';

interface IProps extends Omit<AutocompleteProps<any, any, any, any>, 'onChange' | 'renderInput' | 'options'> {
  list: string[];
  onChange: (updatedList: string[]) => void;
  value: string[];
  label: string;
  placeholder?: string;
  error?: string;
}

const filter = createFilterOptions<string>({ ignoreCase: true, trim: true });

export const TagsAutocomplete = ({ list, value, onChange, label, placeholder, error, ...props }: IProps) => {
  const onChangeHandler = useCallback((e: React.SyntheticEvent, value: string[]) => {
    onChange(value);
  }, [onChange]);
  return (
    <Autocomplete
      multiple
      id="tags-standard"
      options={list}
      freeSolo
      autoSelect
      isOptionEqualToValue={(option, value) => option.toLowerCase() === value.toLowerCase()}
      onChange={onChangeHandler}
      getOptionLabel={(option) => option}
      value={value}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label={label}
          placeholder={placeholder}
          error={!!error}
          helperText={error}
        />
      )}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;
        // Suggest the creation of a new value
        const isExisting = options.some((option) => inputValue.toLowerCase() === option.toLowerCase());
        if (inputValue !== '' && !isExisting) {
          filtered.push(inputValue);
        }
        return filtered;
      }}
      {...props}
    />
  );
};